module.exports = __webpack_public_path__ + "img/bg.608328df.png";